// Centralized select options for consistent usage across components

export const SELECT_OPTIONS = {
  membershipStatus: [
    { value: 'all', label: 'All memberships' },
    { value: 'active', label: 'Active' },
    { value: 'expired', label: 'Expired' },
    { value: 'upcoming', label: 'Upcoming' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'none', label: 'No Membership' },
  ] as const,

  activityLogActions: [
    { value: 'all', label: 'All Actions' },
    { value: 'class_created', label: 'Class Created' },
    { value: 'class_updated', label: 'Class Updated' },
    { value: 'class_deleted', label: 'Class Deleted' },
    { value: 'class_booking_created', label: 'Class Booking Created' },
    { value: 'class_booking_cancelled', label: 'Class Booking Cancelled' },
    { value: 'class_booking_updated', label: 'Class Booking Updated' },
    { value: 'class_booking_attendance_marked', label: 'Attendance Marked' },
    { value: 'class_category_created', label: 'Class Category Created' },
    { value: 'class_category_updated', label: 'Class Category Updated' },
    { value: 'class_category_deleted', label: 'Class Category Deleted' },
    { value: 'class_location_created', label: 'Class Location Created' },
    { value: 'class_location_updated', label: 'Class Location Updated' },
    { value: 'class_location_deleted', label: 'Class Location Deleted' },
    { value: 'coach_created', label: 'Coach Created' },
    { value: 'coach_updated', label: 'Coach Updated' },
    { value: 'coach_deleted', label: 'Coach Deleted' },
    { value: 'member_created', label: 'Member Created' },
    { value: 'member_updated', label: 'Member Updated' },
    { value: 'member_deleted', label: 'Member Deleted' },
    { value: 'member_hard_deleted', label: 'Member Hard Deleted' },
    { value: 'member_privacy_updated', label: 'Member Privacy Updated' },
    { value: 'member_note_created', label: 'Member Note Created' },
    { value: 'member_note_updated', label: 'Member Note Updated' },
    { value: 'member_note_deleted', label: 'Member Note Deleted' },
    { value: 'member_file_uploaded', label: 'Member File Uploaded' },
    { value: 'member_file_updated', label: 'Member File Updated' },
    { value: 'member_file_deleted', label: 'Member File Deleted' },
    { value: 'member_checked_in', label: 'Member Checked In' },
    { value: 'check_in_deleted', label: 'Check-in Deleted' },
    { value: 'member_webcam_photo_added', label: 'Webcam Photo Added' },
    { value: 'member_webcam_photo_updated', label: 'Webcam Photo Updated' },
    { value: 'member_profile_photo_uploaded', label: 'Profile Photo Uploaded' },
    { value: 'member_photo_deactivated', label: 'Profile Photo Deactivated' },
    { value: 'member_waiver_signed', label: 'Waiver Signed' },
    { value: 'member_password_reset_by_admin', label: 'Password Reset by Admin' },
    { value: 'membership_created', label: 'Membership Created' },
    { value: 'membership_updated', label: 'Membership Updated' },
    { value: 'membership_deleted', label: 'Membership Deleted' },
    { value: 'membership_cancelled', label: 'Membership Cancelled' },
    { value: 'membership_upgraded', label: 'Membership Upgraded' },
    { value: 'membership_transferred', label: 'Membership Transferred' },
    { value: 'membership_refunded', label: 'Membership Refunded' },
    { value: 'membership_refund_voided', label: 'Membership Refund Voided' },
    { value: 'membership_refund_settled', label: 'Membership Refund Settled' },
    { value: 'membership_note_created', label: 'Membership Note Created' },
    { value: 'membership_note_updated', label: 'Membership Note Updated' },
    { value: 'membership_note_deleted', label: 'Membership Note Deleted' },
    { value: 'admin_user_created', label: 'Admin User Created' },
    { value: 'admin_user_updated', label: 'Admin User Updated' },
    { value: 'admin_user_deleted', label: 'Admin User Deleted' },
    { value: 'admin_password_changed', label: 'Admin Password Changed' },
    { value: 'admin_account_switched', label: 'Admin Switched (PIN)' },
    { value: 'admin_pin_enabled', label: 'Admin PIN Enabled' },
    { value: 'admin_pin_changed', label: 'Admin PIN Changed' },
    { value: 'admin_pin_disabled', label: 'Admin PIN Disabled' },
    { value: 'admin_pin_switch_failed', label: 'Admin PIN Switch Failed' },
    { value: 'waitlist_joined', label: 'Waitlist Added' },
    { value: 'waitlist_left', label: 'Waitlist Left' },
    { value: 'waitlist_removed', label: 'Waitlist Removed' },
    { value: 'bpa_created', label: 'BPA Created' },
    { value: 'bpa_updated', label: 'BPA Updated' },
    { value: 'bpa_deleted', label: 'BPA Deleted' },
    { value: 'membership_freeze_added', label: 'Membership Freeze Added' },
    { value: 'membership_freeze_updated', label: 'Membership Freeze Updated' },
    { value: 'membership_freeze_deleted', label: 'Membership Freeze Deleted' },
    { value: 'pt_session_created', label: 'PT Session Created' },
    { value: 'pt_session_updated', label: 'PT Session Updated' },
    { value: 'pt_session_deleted', label: 'PT Session Deleted' },
    { value: 'pt_session_cancelled', label: 'PT Session Cancelled' },
    { value: 'pt_session_marked_paid', label: 'PT Session Marked Paid' },
    { value: 'pt_session_marked_completed', label: 'PT Session Marked Completed' },
    { value: 'pt_session_marked_no_show', label: 'PT Session Marked No-Show' },
    { value: 'pt_session_pack_type_created', label: 'PT Pack Type Created' },
    { value: 'pt_session_pack_type_updated', label: 'PT Pack Type Updated' },
    { value: 'pt_session_pack_type_deleted', label: 'PT Pack Type Deleted' },
    { value: 'pt_session_pack_created', label: 'PT Pack Created' },
    { value: 'pt_session_pack_updated', label: 'PT Pack Updated' },
    { value: 'pt_session_pack_deleted', label: 'PT Pack Deleted' },
    { value: 'pt_session_pack_refunded', label: 'PT Pack Refunded' },
    { value: 'pt_session_pack_consumed', label: 'PT Pack Credit Used' },
    { value: 'pt_session_pack_credit_returned', label: 'PT Pack Credit Returned' },
    { value: 'gift_card_created', label: 'Gift Card Created' },
    { value: 'gift_card_cancelled', label: 'Gift Card Cancelled' },
    { value: 'gift_card_redeemed', label: 'Gift Card Redeemed' },
    { value: 'gift_card_expiry_extended', label: 'Gift Card Expiry Extended' },
    { value: 'gift_card_notes_updated', label: 'Gift Card Notes Updated' },
    // Outgoing email categories
    { value: 'class_email_sent', label: 'Class Email Sent' },
    { value: 'class_email_failed', label: 'Class Email Failed' },
    { value: 'membership_email_sent', label: 'Membership Email Sent' },
    { value: 'membership_email_failed', label: 'Membership Email Failed' },
    { value: 'membership_expired_email_sent', label: 'Membership Expired Email Sent' },
    { value: 'membership_expired_email_failed', label: 'Membership Expired Email Failed' },
    { value: 'membership_transfer_out_email_sent', label: 'Transfer (Out) Email Sent' },
    { value: 'membership_transfer_out_email_failed', label: 'Transfer (Out) Email Failed' },
    { value: 'membership_transfer_in_email_sent', label: 'Transfer (In) Email Sent' },
    { value: 'membership_transfer_in_email_failed', label: 'Transfer (In) Email Failed' },
    { value: 'membership_expired_email_exception', label: 'Membership Expired Email Exception' },
    { value: 'welcome_email_sent', label: 'Welcome Email Sent' },
    { value: 'welcome_email_failed', label: 'Welcome Email Failed' },
    { value: 'password_reset_email_sent', label: 'Password Reset Email Sent' },
    { value: 'password_reset_email_failed', label: 'Password Reset Email Failed' },
    { value: 'waiver_email_sent', label: 'Waiver Email Sent' },
    { value: 'waiver_email_failed', label: 'Waiver Email Failed' },
    // Member email sync (auth sync, not outgoing mail)
    { value: 'member_email_sync_triggered', label: 'Member Email Sync Triggered' },
    { value: 'member_email_sync_success', label: 'Member Email Sync Success' },
    { value: 'member_email_sync_failed', label: 'Member Email Sync Failed' },
    { value: 'member_email_sync_error', label: 'Member Email Sync Error' },
    { value: 'member_email_sync_skipped', label: 'Member Email Sync Skipped' },
    { value: 'member_email_sync_frontend', label: 'Member Email Sync Frontend' },
  ] as const,

  activityLogEntityTypes: [
    { value: 'all', label: 'All Types' },
    { value: 'class', label: 'Classes' },
    { value: 'class_category', label: 'Class Categories' },
    { value: 'member', label: 'Members' },
    { value: 'member_note', label: 'Member Notes' },
    { value: 'member_file', label: 'Member Files' },
    { value: 'member_webcam_photo', label: 'Webcam Photos' },
    { value: 'membership', label: 'Memberships' },
    { value: 'membership_transfer', label: 'Membership Transfers' },
    { value: 'membership_refund', label: 'Membership Refunds' },
    { value: 'check_in', label: 'Check-ins' },
    { value: 'waitlist', label: 'Waitlists' },
    { value: 'bpa', label: 'BPA' },
    { value: 'pt_session', label: 'PT Sessions' },
    { value: 'pt_session_pack', label: 'PT Packs' },
    { value: 'pt_session_pack_type', label: 'PT Pack Types' },
  ] as const,

  classCategories: [
    { value: 'none', label: 'No Category' },
  ] as const,

  accessLevels: [
    { value: 'super_admin', label: 'Super Admin' },
    { value: 'manager', label: 'Manager' },
    { value: 'staff', label: 'Staff' },
  ] as const,

  gender: [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'prefer_not_to_say', label: 'Prefer not to say' },
  ] as const,

  paymentMethod: [
    { value: 'cash', label: 'Cash' },
    { value: 'card', label: 'Card' },
    { value: 'bank_transfer', label: 'Bank transfer' },
    { value: 'e_wallet', label: 'E-Wallet' },
    { value: 'voucher', label: 'Voucher / Gift card' },
    { value: 'qris', label: 'QRIS' },
  ] as const,

  // How a refund left the club. Mirrors paymentMethod plus gift-card credit,
  // which is the only NON-CASH method: it returns value to the original card
  // rather than moving money, so it must never reduce a cash-flow figure.
  refundMethod: [
    { value: 'cash', label: 'Cash' },
    { value: 'card', label: 'Card reversal' },
    { value: 'bank_transfer', label: 'Bank transfer' },
    { value: 'e_wallet', label: 'E-Wallet' },
    { value: 'qris', label: 'QRIS' },
    { value: 'gift_card_credit', label: 'Credit back to gift card' },
  ] as const,

  // How a membership came about. Predefined and not editable from admin.
  // Stored lowercase on memberships.member_type (NULL = unset).
  // 'staff' and 'coach' additionally drive the Odoo F&B discount: while a
  // valid membership with one of those types covers today, the daily/event
  // Odoo sync puts the member's partner on the matching pricelist (Staff 50%,
  // Coach 20% — see api/_lib/yearly-pricelist.ts). Staff here means a
  // full-time employee holding a MEMBER account; actual Employees-directory
  // staff get their discount via the employee sync instead.
  memberType: [
    { value: 'paid', label: 'Paid full price' },
    { value: 'discounted', label: 'Discounted' },
    { value: 'complimentary', label: 'Complimentary' },
    { value: 'influencer', label: 'Influencer' },
    { value: 'corporate', label: 'Corporate' },
    { value: 'staff', label: 'Staff (50% F&B)' },
    { value: 'coach', label: 'Coach (20% F&B)' },
  ] as const,
} as const;

// Type helpers for better TypeScript support
export type MembershipStatusValue = typeof SELECT_OPTIONS.membershipStatus[number]['value'];
export type ActivityLogActionValue = typeof SELECT_OPTIONS.activityLogActions[number]['value'];
export type ActivityLogEntityTypeValue = typeof SELECT_OPTIONS.activityLogEntityTypes[number]['value'];
export type AccessLevelValue = typeof SELECT_OPTIONS.accessLevels[number]['value'];
export type GenderValue = typeof SELECT_OPTIONS.gender[number]['value'];
export type RefundMethodValue = typeof SELECT_OPTIONS.refundMethod[number]['value'];
export type PaymentMethodValue = typeof SELECT_OPTIONS.paymentMethod[number]['value'];
export type MemberTypeValue = typeof SELECT_OPTIONS.memberType[number]['value'];

// Member Type is optional (NULL = unset). Radix Select can't hold an empty
// value, so forms use this sentinel to represent "no selection" — letting an
// admin clear a previously-set type back to NULL. `normalizeMemberType` maps it
// (and any empty value) back to null before the value is persisted.
export const MEMBER_TYPE_UNSET = '__none__';

export const MEMBER_TYPE_FIELD_OPTIONS = [
  { value: MEMBER_TYPE_UNSET, label: '— Not set —' },
  ...SELECT_OPTIONS.memberType,
];

export const normalizeMemberType = (value?: string | null): string | null =>
  !value || value === MEMBER_TYPE_UNSET ? null : value;
